<div style="width: 100%; height: 100%; padding-left: 25px; padding-right: 25px">
  <!-- Registration Table -->
  <div id="mainDivEvents" [bentoBusyLoader]="isMainBusyLoaderBusy">
    <div>
      <h2 class="events-heading">Event Webhook Registrations</h2>
      <!-- BENTO TOOLBAR -->
      <bento-toolbar class="bento-toolbar" [items]="toolbarData">
        <!-- PROJECTED NAVBAR LEFT CONTENT -->
        <div class="navbar-left">
          <div class="example-header">
            <span class="bento-search">
              <input type="text" class="form-control" bentoReset #filter placeholder="Filter by event name"
                     (input)="filterEvent($event)" />
            </span>
          </div>
        </div>
      </bento-toolbar>
    </div>
    <!-- FLEXGRID HEADER AND FILTERS -->
    <wj-flex-grid #flexGrid class="bento-flex-grid has-row-hover" [class.list-grid]="isListGrid" [itemsSource]="data"
                  [isReadOnly]="true" [stickyHeaders]="true" [showMarquee]="true" [showSort]="true" (initialized)="gridInitialized()">
      <!-- FLEXGRID FILTER -->
      <wj-flex-grid-filter #filter [filterColumns]="filteredColumns"></wj-flex-grid-filter>
      <ng-template wjFlexGridCellTemplate [cellType]="'RowHeader'" let-col="col" let-row="row" let-item="item">
        <div *ngIf="col.index === 0">{{ row.index+1 }}</div>
        <div *ngIf="col.index === 1">
        </div>
      </ng-template>

      <!-- FLEXGRID Columns -->
      <wj-flex-grid-column [header]="'Actions'" [allowDragging]="false" [width]="100" [cssClass]="'action-column'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
          <span class="bento-icon-edit grid-action-icon"
                (click)="actions.editRow(item); $event.stopPropagation(); $event.preventDefault()" ngbTooltip="Edit"
                title="Edit"></span>
          <span class="bento-icon-remove grid-action-icon"
                (click)="actions.deleteRow(item); $event.stopPropagation(); $event.preventDefault()" ngbTooltip="Delete"
                title="Delete"></span>
        </ng-template>
      </wj-flex-grid-column>

      <wj-flex-grid-column [header]="'Event Name'" [binding]="'eventName'"
                           [visible]="columnDefinitionsByBinding['eventName'].visible" [width]="'*'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
          <span ngbTooltip="{{ item.eventName }}" title="{{ item.eventName }}" class="cell-style">
            {{ item.eventName }}
          </span>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'Description'" [binding]="'description'"
                           [visible]="columnDefinitionsByBinding['description'].visible" [width]="'*'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
          <span ngbTooltip="{{ item.description }}" title="{{ item.description }}" class="cell-style">
            {{ item.description }}
          </span>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'Associated Product'" [binding]="'associatedProduct'"
                           [visible]="columnDefinitionsByBinding['associatedProduct'].visible" [width]="'*'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
          <span ngbTooltip="{{ item.associatedProduct }}" title="{{ item.associatedProduct }}" class="cell-style">
            {{ item.associatedProduct }}
          </span>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'Associated Channel'" [binding]="'associatedChannel'"
                           [visible]="columnDefinitionsByBinding['associatedChannel'].visible" [width]="'*'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
          <span ngbTooltip="{{ item.associatedChannel }}" title="{{ item.associatedChannel }}" class="cell-style">
            {{ item.associatedChannel }}
          </span>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'Callback URL'" [binding]="'url'"
                           [visible]="columnDefinitionsByBinding['url'].visible" [width]="'*'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
          <span ngbTooltip="{{ item.url }}" title="{{ item.url }}" class="cell-style">
            {{ item.url }}
          </span>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'Created By'" [binding]="'createdBy'"
                           [visible]="columnDefinitionsByBinding['createdBy'].visible" [width]="'*'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
          <span ngbTooltip="{{ item.createdBy }}" title="{{ item.createdBy }}" class="cell-style">
            {{ item.createdBy }}
          </span>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'Creation Date'" [binding]="'creationDate'"
                           [visible]="columnDefinitionsByBinding['creationDate'].visible" [width]="'*'" format="d">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
          <span ngbTooltip="{{ item.creationDate }}" title="{{ item.creationDate }}" class="cell-style">
            {{ item.creationDate }}
          </span>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'Status'" [binding]="'endpoint_state'"
                           [visible]="columnDefinitionsByBinding['endpoint_state'].visible" [width]="'*'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
          <span ngbTooltip="{{ item.endpoint_state }}" title="{{ item.endpoint_state }}" class="cell-style">
            {{ item.endpoint_state }}
          </span>
        </ng-template>
      </wj-flex-grid-column>
    </wj-flex-grid>
    <!-- DATA PAGINATION DISPLAY SECTION -->
    <div *ngIf="data != undefined && data.totalItemCount > 0; else nodata">
      <!-- BENTO PAGINATION -->
      <bento-pagination *ngIf="data != undefined  && totalItemCount > 0" [page]="data.pageIndex + 1"
                        [directionLinks]="true" [boundaryLinks]="true" [totalItems]="data.totalItemCount"
                        [(itemsPerPage)]="data.pageSize" (itemsPerPageChange)="onPageSizeChanged($event)"
                        (pageChange)="onPageChanged($event)" [goToLink]="false"></bento-pagination>
    </div>
    <!-- NO DATA SECTION -->
    <ng-template #nodata>
      <app-no-events></app-no-events>
    </ng-template>

  </div>
  <router-outlet></router-outlet>
</div>